export enum DataType {
  Number,
  Date,
}

export enum EntityType {
  Category,
  SubCategory,
  Product,
  Customer,
  Supplier,
  Sale,
  Purchase,
  SaleReturn,
  PurchaseReturn,
}
